import React from 'react'
import { graphql } from 'gatsby'

import Layout from 'components/layout'
import SEO from 'components/seo'
import Content from 'sections/Article/Content'
import Related from 'sections/Article/Related'

type Props = {
  data: any
  location: any
  pageContext: any
}

const ArticlePage: React.FC<Props> = ({ data, location, pageContext }) => {
  const allArticles = data.allContentfulArticle.nodes

  return (
    <Layout>
      <SEO
        title={pageContext.title}
        description={
          pageContext.metaDescription ? pageContext.metaDescription : ''
        }
      />
      <Content
        article={pageContext}
        articles={allArticles}
        lastType={location.state ? location.state.lastType : 'Blog'}
        lastCategory={
          location.state ? location.state.lastCategory : 'Recent articles'
        }
      />
      <Related currentArticle={pageContext} articles={allArticles} />
    </Layout>
  )
}

export const pageQuery = graphql`
  query articleQuery {
    allContentfulArticle(
      filter: { title: { nin: "DUMMY DO NOT DELETE" } }
      limit: 4
    ) {
      nodes {
        tags
        title
        type
        coverImage {
          file {
            url
          }
        }
      }
    }
  }
`

export default ArticlePage
